import { useContext } from 'react';
import { Header, AppLayout, ContentLayout, Grid } from '@cloudscape-design/components';

import { LocalNavigation, Breadcrumbs, NavigationContext } from '../../common/navigation';
import PlusSubscriptionInfo from '../plus';
import Feed from '../../feed/feed';

export default function PlusExamples() {
  const { navigationSize, navigationOpen, setNavigationOpen } = useContext(NavigationContext);

  return (
    <AppLayout
      breadcrumbs={
        <Breadcrumbs
          items={[
            { text: 'Plans', href: '/subscription' },
            { text: 'Plus+', href: '' },
          ]}
        />
      }
      className="app-layout"
      content={
        <ContentLayout header={<Header variant="h1">Examples of Plus+ Plan Rooms</Header>}>
          <Grid
            gridDefinition={[
              {
                colspan: {
                  default: 12,
                  l: 4,
                  s: 4,
                },
              },
              {
                colspan: {
                  default: 12,
                  l: 8,
                  s: 8,
                },
              },
            ]}
          >
            <PlusSubscriptionInfo hideExamples moreInfo />
            <Feed eventType="created" userId="2" hideUsers />
          </Grid>
        </ContentLayout>
      }
      contentType="default"
      headerSelector=".top-navigation"
      navigation={<LocalNavigation />}
      navigationOpen={navigationOpen}
      navigationWidth={navigationSize}
      toolsHide
      onNavigationChange={(event) => setNavigationOpen(event.detail.open)}
    />
  );
}
